import { render, staticRenderFns } from "./PreApprovalLettersTable.vue?vue&type=template&id=6c712f12&scoped=true&"
import script from "./PreApprovalLettersTable.vue?vue&type=script&lang=js&"
export * from "./PreApprovalLettersTable.vue?vue&type=script&lang=js&"
import style0 from "./PreApprovalLettersTable.vue?vue&type=style&index=0&id=6c712f12&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c712f12",
  null
  
)

export default component.exports